import { render, staticRenderFns } from "./StudyHeroList.vue?vue&type=template&id=7b41a07f&scoped=true&"
import script from "./StudyHeroList.vue?vue&type=script&lang=js&"
export * from "./StudyHeroList.vue?vue&type=script&lang=js&"
import style0 from "./StudyHeroList.vue?vue&type=style&index=0&id=7b41a07f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b41a07f",
  null
  
)

export default component.exports